






















































































































































































































































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, LessonClass } from "../../modules/teacher/LessonClassList"

export interface Data {
  condition: SearchCondition
  lessonClasses: LessonClass[]
  fields: any[]
  perPage: number
  isAllDeleteChecked: boolean
  isShow: boolean
  errors: string[]
  SheetTypeEnum: Readonly<{Report: number; LessonKyouzai: number; LessonTest: number;}>
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.baseSheetListCondition,
      lessonClasses: [],
      fields: [
        {key: "lesson_code", label: "講座CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "subject_name", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "lesson_class_no", label: "回次", sortable: true, class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "name", label: "講座名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "user_name", label: "担当講師", sortable: true, class: 'text-center b-table-th-td'},
        {key: "point", label: "評価", sortable: true, class: 'text-center b-table-th-td'},
        {key: "start_datetime_at", label: "開始", sortable: true, class: 'text-center b-table-th-td'},
        {key: "end_datetime_at", label: "終了", sortable: true, class: 'text-center b-table-th-td'},
        {key: "is_published", label: "公開状態", class: 'text-center b-table-th-td', thStyle: {width: "70px"}},
        {key: "kyouzai_field_names_completed", label: "設問情報", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "kyouzai_answer_image_completed", label: "解答用紙", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "kyouzai_field_positions_completed", label: "設問枠", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "kyouzai_explanation_image_completed", label: "解答解説", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "kyouzai_status", label: "状態", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "kyouzai_edit", label: "設定", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_field_names_completed", label: "設問情報", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_corretct_image_completed", label: "模範解答", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_field_positions_completed", label: "設問枠", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_score_positions_completed", label: "得点枠", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_answer_image_completed", label: "解答用紙", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_question_image_completed", label: "解答用紙", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_status", label: "状態", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        {key: "test_edit", label: "設定", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},

        // {key: "questionnaire_status", label: "状態", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},
        // {key: "questionnaire_edit", label: "設定", class: 'text-center b-table-th-td', thStyle: {width: "60px"}},

        {key: "delete", label: "削除", class: 'text-center b-table-th-td', thStyle: {width: "40px"}},
      ],
      perPage: 20,
      isAllDeleteChecked: false,
      isShow: false,
      errors: [],
      SheetTypeEnum: Common.SheetTypeEnum,
    });

    /******************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ******************************/

    const adjustHeight = () => {
      const winH = window.innerHeight;
      const tableArea = document.getElementById("table-area");

      if(tableArea != null){
        tableArea.style.height = (winH - tableArea.offsetTop - 50) + "px";
      }
    };

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.currentPage = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      state.errors = []
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/lesson_class_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.lessonClasses = response.data.lesson_classes.map((x: any) => new LessonClass(x)); 
        context.root.$store.commit("setBaseSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 採点設定画面へ
     ******************************/

    const testSettingClick = (lessonClass: LessonClass) => {
      // 採点設定の進捗により遷移先を制御
      if (!lessonClass.test_field_names_completed) {
        context.root.$router.push(`/teacher_site/field_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      if (!lessonClass.test_corretct_image_completed) {
        context.root.$router.push(`/teacher_site/correct_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      if (!lessonClass.test_field_positions_completed) {
        context.root.$router.push(`/teacher_site/position_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      if (!lessonClass.test_score_positions_completed) {
        context.root.$router.push(`/teacher_site/score_position_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      if (!lessonClass.test_answer_image_completed) {
        context.root.$router.push(`/teacher_site/answer_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      if (!lessonClass.test_question_image_completed) {
        context.root.$router.push(`/teacher_site/question_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        return;
      }
      context.root.$router.push(`/teacher_site/question_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
    };

    /******************************
     * レポート削除
     ******************************/

    const deleteLessonClasses = async (): Promise<void> => {

      state.errors = [];

      const delete_ids: number[] = state.lessonClasses.filter(x => x.is_checked).map(x => x.lesson_class_id);

      if(delete_ids.length == 0){
        alert("削除対象レポートが選択されていません。");
        return;
      }

      let is_exists_sheet = false;

      const base_sheet_ids: number[] = [];
      state.lessonClasses.filter(x => x.is_checked).forEach(x => {
        base_sheet_ids.push(x.test_base_sheet_id);
        base_sheet_ids.push(x.kyouzai_base_sheet_id);
      })

      // 提出済みレポート有無を検索
      await http.post(`/api/teacher/lesson_class_list/is_exists_sheet`, {base_sheet_ids: base_sheet_ids}).then(response => {
        is_exists_sheet = response.data.is_exists_sheet;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      if(is_exists_sheet){
        alert("既に提出済み答案が存在する試験は削除できません。");
        return;
      }

      if(!window.confirm("選択しているレポートを削除します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/lesson_class_list/delete_lesson_classes`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * ページ内のレポート全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: LessonClass) => x.is_checked = isChecked);
    };

    /******************************
     * ページ切り替え
     ******************************/

    const pageChanged = () => {
      state.isAllDeleteChecked = false;
      state.lessonClasses.forEach(x => x.is_checked = false);
    };

    /******************************
     * 一括アップロード画面へ
     ******************************/

    const toIkkatuUpload = (url: string, sheet_type: number) => {
      context.root.$store.commit("setSheetType", sheet_type);
      context.root.$router.push(url);
    }

    /******************************
     * 採点設定画面へ
     ******************************/

    const saitenSettingClick = (lessonClass: LessonClass, sheet_type: number) => {

      context.root.$store.commit("setSheetType", sheet_type);

      if(sheet_type == Common.SheetTypeEnum.LessonKyouzai){
        // 教材の設定アイコン押下
        if (!lessonClass.kyouzai_field_names_completed) {
          context.root.$router.push(`/teacher_site/field_edit/${lessonClass.kyouzai_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.kyouzai_answer_image_completed) {
          context.root.$router.push(`/teacher_site/answer_image_upload/${lessonClass.kyouzai_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.kyouzai_field_positions_completed) {
          context.root.$router.push(`/teacher_site/position_edit/${lessonClass.kyouzai_base_sheet_id}`).catch(err => {});
        }else{
          context.root.$router.push(`/teacher_site/explanation_image_upload/${lessonClass.kyouzai_base_sheet_id}`).catch(err => {});
        }
      }else{
        // テストの設定アイコン押下
        if (!lessonClass.test_field_names_completed) {
          context.root.$router.push(`/teacher_site/field_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.test_corretct_image_completed) {
          context.root.$router.push(`/teacher_site/correct_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.test_field_positions_completed) {
          context.root.$router.push(`/teacher_site/position_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.test_score_positions_completed) {
          context.root.$router.push(`/teacher_site/score_position_edit/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.test_answer_image_completed) {
          context.root.$router.push(`/teacher_site/answer_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else if (!lessonClass.test_question_image_completed) {
          context.root.$router.push(`/teacher_site/question_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }else {
          context.root.$router.push(`/teacher_site/question_image_upload/${lessonClass.test_base_sheet_id}`).catch(err => {});
        }
      }
    };

    /******************************
     * アンケートボタンクリック
     ******************************/

    const questionnaireSettingClick = (lesson_class_id: number) => {
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.LessonKyouzai);
      context.root.$router.push(`/teacher_site/lesson_questionnaire_edit/${lesson_class_id}`).catch(err => {});
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShow = true;
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      document.body.style.overflow = "";
    });

    const formatDate = Common.formatDate;

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      search,
      clearCondition,
      testSettingClick,
      deleteLessonClasses,
      allSelectChanged,
      pageChanged,
      toIkkatuUpload,
      saitenSettingClick,
      questionnaireSettingClick,
      formatDate,
    };
  }
});
